import React from 'react';
import DropdownList from '../../FormElements/DropdownList';
import AdvancedDataTable from '../../DataTables/AdvancedDataTable';
import MobileDataTableCard from '../../DataTables/MobileDataTableCard';
import Cell from '../../DataTables/DataTableComponents/Cell';

export default function PropertyInvoicesCard(props) {
	return (
		<div className="PropertyInvoicesCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">Invoices</h2>
					<DropdownList
						label="Category"
						displayLabel={false}
						// onChange={this.onChange}
						id="dateRange"
						name="dateRange"
						// value={this.state.dateRange}
						data={[
							{
								id: 1,
								name: 'All'
							},
							{
								id: 2,
								name: ' Subscription'
							},
							{
								id: 3,
								name: 'Lodging Taxes'
							},
							{
								id: 4,
								name: 'License Fee'
							},
							{
								id: 5,
								name: 'Property Setup'
							}
						]}
					/>
					<DropdownList
						label="Year"
						displayLabel={false}
						// onChange={this.onChange}
						id="dateRange"
						name="dateRange"
						// value={this.state.dateRange}
						data={[
							{
								id: 1,
								name: '2023'
							}
						]}
					/>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="contents lg:hidden">
						<MobileDataTableCard
							margin="my-0"
							data={[
								{
									id: 1,
									order_date: '01/18/2023',
									order_type: 'Property Setup',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 175.0
								},
								{
									id: 2,
									order_date: '01/18/2023',
									order_type: 'License Fee',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 65.0
								},
								{
									id: 3,
									order_date: '02/01/2023',
									order_type: 'Subscription',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 25.0
								},
								{
									id: 4,
									order_date: '02/01/2023',
									order_type: 'Lodging Taxes',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 457.25
								}
							]}
							// endpoint={props.get_properties_endpoint}
							rowRenderer={(row) => {
								// console.log('PropertyInvoicesCard - invoice row', row);
								let labels = [
									{
										displayName: 'Invoice #',
										apiName: 'invoice_id',
										alignment: 'left'
									},
									{
										displayName: 'Date',
										apiName: 'invoice_date',
										alignment: 'left'
									},
									{
										displayName: 'Category',
										apiName: 'invoice_category',
										alignment: 'left'
									},
									{
										displayName: 'Payment Account',
										apiName: 'payment_account',
										alignment: 'left'
									},
									{
										displayName: 'Payment Amount',
										apiName: 'payment_amount',
										alignment: 'right'
									}
								];
								return (
									<div
										key={row.id}
										className="p-4 bg-gray-50 border-t text-gray-800"
									>
										<div className="font-semibold">{labels[0].displayName}</div>
										<div>
											<Cell value={row.id} type="text" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[1].displayName}
										</div>
										<div>
											<Cell value={row.order_date} type="date" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[2].displayName}
										</div>
										<div>
											<Cell value={row.order_type} type="text" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[3].displayName}
										</div>
										<div>
											<Cell value={row.payment_account} type="text" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[4].displayName}
										</div>
										<div>
											<Cell
												value={<span>${row.payment_amount}</span>}
												type="text"
											/>
										</div>
									</div>
								);
							}}
						/>
					</div>
					<div className="hidden lg:contents">
						<AdvancedDataTable
							margin="my-0"
							shadow="shadow-sm"
							data={[
								{
									id: 1,
									order_date: '01/18/2023',
									order_type: 'Property Setup',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 175.0
								},
								{
									id: 2,
									order_date: '01/18/2023',
									order_type: 'License Fee',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 65.0
								},
								{
									id: 3,
									order_date: '02/01/2023',
									order_type: 'Subscription',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 25.0
								},
								{
									id: 4,
									order_date: '02/01/2023',
									order_type: 'Lodging Taxes',
									payment_account: "Matt's Checking XXX1780",
									payment_amount: 457.25
								}
							]}
							// endpoint={props.get_properties_endpoint}
							style="text-gray-800 border-b-2 border-gray-300 font-semibold"
							columns={[
								{
									displayName: 'Invoice #',
									apiName: 'invoice_id',
									alignment: 'left'
								},
								{
									displayName: 'Date',
									apiName: 'invoice_date',
									alignment: 'left'
								},
								{
									displayName: 'Category',
									apiName: 'invoice_category',
									alignment: 'left'
								},
								{
									displayName: 'Payment Account',
									apiName: 'payment_account',
									alignment: 'left'
								},
								{
									displayName: 'Payment Amount',
									apiName: 'payment_amount',
									alignment: 'right'
								}
							]}
							rowRenderer={(row) => {
								// console.log('PropertiesCard - property row', row);
								return (
									<tr key={row.id} className="bg-white border-t text-gray-800">
										<td className="px-8 py-3 text-left">
											<Cell value={row.id} type="text" />
										</td>
										<td className="pl-8 pr-6 py-3 text-left">
											<Cell value={row.order_date} type="date" />
										</td>
										<td className="pl-8 pr-6 py-3 text-left">
											<Cell value={row.order_type} type="text" />
										</td>
										<td className="pl-8 pr-6 py-3 text-left">
											<Cell value={row.payment_account} type="text" />
										</td>
										<td className="pl-8 pr-8 py-3 text-right w-80">
											<Cell
												value={<span>${row.payment_amount}</span>}
												type="text"
											/>
										</td>
									</tr>
								);
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
